export default __webpack_public_path__ + "static/media/TeamCred.ca14dac0.svg";